module.exports = __webpack_public_path__ + "img/PerksTopPictureOffer.d20a3a49.png";